import { useEffect } from 'react';

import { useEcommerceReset } from '~/features/tracking/hooks/useEcommerceReset';
import { useListState } from '~/features/tracking/hooks/useListState';
import { GA4ProductViewEvent, UaProductViewEvent } from '~/features/tracking/model';
import { createGA4ProductTrackingObject } from '~/features/tracking/utils/createGA4ProductTrackingObject';
import { createProductTrackingObject } from '~/features/tracking/utils/createProductTrackingObject';
import { pushToDataLayer } from '~/features/tracking/utils/pushToDataLayer';
import { IVariationDetails } from '~/lib/data-contract';
import { useFrame } from '~/shared/utils/frame/hooks/useFrame';
import { isSSR } from '~/shared/utils/platform/utils/platform';

export const useProductDetailTracking = (variation: IVariationDetails) => {
	const { data: frame } = useFrame();
	const currency = frame.market?.currency?.id.toUpperCase() || '';
	const resetEcommerce = useEcommerceReset();
	const { prevListId, prevListName } = useListState();

	useEffect(() => {
		if (isSSR) {
			return;
		}

		const productViewEvent: UaProductViewEvent = {
			event: 'eec_productView',
			ecommerce: {
				currencyCode: currency,
				detail: {
					actionList: {},
					products: [createProductTrackingObject(variation)],
				},
			},
		};

		if (prevListId) {
			productViewEvent.ecommerce.detail.actionList.list = prevListName?.toLowerCase();
		}

		resetEcommerce();
		pushToDataLayer<UaProductViewEvent>(productViewEvent);

		resetEcommerce();
		pushToDataLayer<GA4ProductViewEvent>({
			event: 'view_item',
			ecommerce: {
				items: [
					createGA4ProductTrackingObject({
						variation,
						currency: currency,
						itemListId: prevListId?.toLowerCase(),
						itemListName: prevListName?.toLowerCase(),
					}),
				],
			},
		});
	}, [variation]);
};
